import { render } from "./Dropdown3.vue?vue&type=template&id=53ca8a5c"
import script from "./Dropdown3.vue?vue&type=script&lang=ts"
export * from "./Dropdown3.vue?vue&type=script&lang=ts"
script.render = render

export default script